import { LightningBoltIcon } from '@radix-ui/react-icons'
import Link from 'next/link'
import { GrafbaseThemes } from 'style'

import { websitePaths } from 'domains/website/website.paths'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import { GitBranch } from 'components/atomic/atoms/icons/git-branch'
import { Shield } from 'components/atomic/atoms/icons/shield'
import Text from 'components/atomic/atoms/text'

import { ChartIcon } from '../features/edge-caching/icons/chart-icon'
import { SpeedIcon } from '../features/edge-caching/icons/speed-icon'
import {
  HomepageSectionSubtitle,
  HomepageSectionTitle,
  SectionTitleContainer,
} from '../index/@shared/homepage-section-title'
import { CliIcon } from './icons/cli'

const p = 125
const container = 'xl'
const sections = [
  {
    title: 'Edge Gateway',
    text: 'Connect databases and APIs to a single GraphQL endpoint at the edge.',
    icon: SpeedIcon,
    href: websitePaths.edgeGateway,
  },
  {
    title: 'Auth',
    text: 'Configure auth in minutes with your favorite identity providers.',
    icon: Shield,
    href: websitePaths.auth,
  },
  {
    title: 'Edge Caching',
    text: 'Cache any data source and make it lightning fast globally.',
    icon: LightningBoltIcon,
    href: websitePaths.edgeCaching,
  },
  {
    title: 'Branching',
    text: 'Collaborate on changes with instant preview branches.',
    icon: GitBranch,
    href: websitePaths.branching,
  },
  {
    title: 'CLI',
    text: 'Local development with zero configuration or dependencies.',
    icon: CliIcon,
    href: websitePaths.cli,
  },
  {
    title: 'Analytics',
    text: 'Monitor performance and identify bottlenecks in realtime.',
    icon: ChartIcon,
    href: websitePaths.analytics,
  },
]
const BatteriesIncluded = () => {
  return (
    <Box
      as="section"
      css={{
        py: p,
      }}
    >
      <Box css={{ container }}>
        <SectionTitleContainer>
          <HomepageSectionTitle>Batteries included</HomepageSectionTitle>
          <HomepageSectionSubtitle>
            Grafbase comes with everything you need to build powerful GraphQL
            APIs.
          </HomepageSectionSubtitle>
        </SectionTitleContainer>

        <Box grid css={{ '@md': { gridCols: 3 }, gap: '$12', mt: '$16' }}>
          {sections.map(({ title, text, href, ...props }) => (
            <Box
              key={title}
              relative
              css={{
                p: '$5',
              }}
            >
              <Box flex items="center" css={{ gap: '$3' }}>
                <Box
                  css={{
                    background:
                      'linear-gradient(135deg, #E2FFF5 0.46%, #89D3B1 100.46%)',
                    [`.${GrafbaseThemes.dark} &`]: {
                      background:
                        'linear-gradient(135deg, #355D50 -0.46%, #0F3427 99.54%), linear-gradient(135deg, #43434A 0%, #171719 100%)',
                    },
                    borderRadius: '$lg',
                    p: '$2',
                    color: '$text1',
                  }}
                >
                  <props.icon height={25} width={25} />
                </Box>
                <Text as="h3" size="2xl" weight="bold">
                  {title}
                </Text>
              </Box>
              <Text as="p" color="text3" css={{ mt: '$4' }}>
                {text}
              </Text>
              <Link href={href}>
                <Button variant="secondary" css={{ mt: '$4' }}>
                  Learn More
                </Button>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default BatteriesIncluded
